var React = require('react');

function ArrowDownCircledInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"_5","data-name":"5"},React.createElement("path",{"d":"M265.55,370.07l90.52-90.51a16,16,0,0,0-22.62-22.62l-66,65.93V153.49a16,16,0,0,0-32,0V322.87l-65.93-65.94a16,16,0,1,0-22.63,22.62l90.51,90.51a15.75,15.75,0,0,0,14.06,4.17A15.8,15.8,0,0,0,265.55,370.07ZM261,0C119.61,0,5,114.61,5,256S119.61,512,261,512,517,397.38,517,256,402.39,0,261,0Zm0,480C137.29,480,37,379.71,37,256S137.29,32,261,32,485,132.29,485,256,384.71,480,261,480Z","transform":"translate(-5)","style":{"fill":"#fff"}})));
}

ArrowDownCircledInline.defaultProps = {"id":"Capa_1","data-name":"Capa 1","viewBox":"0 0 512 512"};

module.exports = ArrowDownCircledInline;

ArrowDownCircledInline.default = ArrowDownCircledInline;
